import React__default from 'react';

const Divider = ({ orientation = 'horizontal', dimension = '100%', padding = 0, }) => {
    return (React__default.createElement("div", { style: {
            paddingTop: orientation === 'horizontal' ? padding : 0,
            paddingBottom: orientation === 'horizontal' ? padding : 0,
            paddingLeft: orientation === 'vertical' ? padding : 0,
            paddingRight: orientation === 'vertical' ? padding : 0,
        } },
        React__default.createElement("div", { style: {
                minHeight: orientation === 'vertical' ? 20 : undefined,
                minWidth: orientation === 'horizontal' ? 20 : undefined,
                height: orientation === 'vertical' ? dimension : undefined,
                width: orientation === 'horizontal' ? dimension : undefined,
                borderLeft: orientation === 'vertical' ? 'solid 1px #CCCCCC' : undefined,
                borderBottom: orientation === 'horizontal' ? 'solid 1px #CCCCCC' : undefined,
                clear: 'both',
            } })));
};

export { Divider as default };
//# sourceMappingURL=Divider.js.map
